import { AlertTriangle } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface AltTextInputProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

export function AltTextInput({ value, onChange, className }: AltTextInputProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <label className="text-xs text-muted-foreground block">Alt text</label>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Describe this image for accessibility"
      />
      {value === '' && (
        <div className="flex items-center gap-1">
          <AlertTriangle className="size-4 text-amber-500" />
          <span className="text-xs text-amber-500">Missing alt text</span>
        </div>
      )}
    </div>
  )
}
